<template>
	<svg class="svg-marker" viewBox="250 170 125 85" width="110" height="80">
		<rect ref="labelBackground" class="label-background" x="0" y="0" width="0" height="0" />
		<text ref="label" class="label" x="311" y="174" alignment-baseline="before-edge" text-anchor="middle">{{ label }}</text>
		<path :class="'marker ' + type" d="M314.55 202.9L315.82 203.1L317.07 203.37L318.29 203.72L319.48 204.14L320.64 204.63L321.75 205.19L322.83 205.81L323.87 206.48L324.86 207.22L325.81 208.02L326.71 208.86L327.56 209.76L328.35 210.71L329.09 211.7L329.77 212.74L330.39 213.82L330.94 214.94L331.43 216.09L331.85 217.28L332.2 218.5L332.48 219.75L332.68 221.03L332.8 222.33L332.84 223.65L332.8 224.97L332.68 226.27L332.48 227.55L332.2 228.8L331.85 230.02L331.43 231.21L330.94 232.36L330.39 233.48L329.77 234.56L329.09 235.6L328.35 236.59L327.56 237.54L326.71 238.44L325.81 239.28L324.86 240.08L323.87 240.82L322.83 241.5L321.75 242.11L320.64 242.67L319.48 243.16L318.29 243.58L317.21 243.89L316.92 244.39L316.19 245.73L315.49 247.11L314.82 248.53L314.18 249.99L313.56 251.48L312.98 253.01L312.43 254.58L311.91 256.19L311.37 254.59L310.8 253.03L310.21 251.51L309.58 250.02L308.93 248.57L308.25 247.15L307.55 245.77L306.82 244.42L306.48 243.84L305.56 243.58L304.37 243.16L303.21 242.67L302.1 242.11L301.02 241.5L299.98 240.82L298.99 240.08L298.04 239.28L297.14 238.44L296.29 237.54L295.5 236.59L294.76 235.6L294.08 234.56L293.46 233.48L292.91 232.36L292.42 231.21L292 230.02L291.65 228.8L291.37 227.55L291.17 226.27L291.05 224.97L291.01 223.65L291.05 222.33L291.17 221.03L291.37 219.75L291.65 218.5L292 217.28L292.42 216.09L292.91 214.94L293.46 213.82L294.08 212.74L294.76 211.7L295.5 210.71L296.29 209.76L297.14 208.86L298.04 208.02L298.99 207.22L299.98 206.48L301.02 205.81L302.1 205.19L303.21 204.63L304.37 204.14L305.56 203.72L306.78 203.37L308.03 203.1L309.3 202.9L310.6 202.78L311.93 202.74L313.25 202.78L314.55 202.9Z"></path>
		<path v-if="type == 'driving'" :transform="'rotate(' + angle + ')'" class="arrow" d="M311.97 225.18L319.64 232.85L311.97 213.68L304.3 232.85L311.97 225.18Z"></path>
		<g v-if="type == 'error' || type == 'green' || type == 'blue'" class="error icon">
			<path d="M309.75 229.49L314.1 229.49L315.55 211.36L308.3 211.36L309.75 229.49Z"></path>
			<path d="M309.75 235.29L314.1 235.29L314.1 231.66L309.75 231.66L309.75 235.29Z"></path>
		</g>
		<path v-if="type == 'parked'" class="parked icon" d="M310.12 211.72L310.71 211.72L311.32 211.73L311.94 211.74L312.57 211.74L313.51 211.8L314.4 211.95L315.24 212.18L316.02 212.49L316.74 212.89L317.4 213.38L317.98 213.94L318.5 214.59L318.94 215.32L319.29 216.12L319.56 217L319.74 217.96L319.82 218.99L319.8 220.03L319.67 220.99L319.43 221.87L319.1 222.68L318.67 223.41L318.16 224.06L317.56 224.63L316.89 225.12L316.15 225.52L315.34 225.83L314.47 226.06L313.55 226.2L312.57 226.24L312.21 226.23L311.86 226.21L311.55 226.2L311.25 226.19L310.98 226.19L310.73 226.19L310.51 226.19L310.31 226.19L310.14 226.19L309.98 226.2L309.86 226.21L309.75 226.23L309.67 226.24L309.67 234.94L305.32 234.94L305.32 211.74L305.81 211.74L306.3 211.73L306.81 211.72L307.33 211.72L307.86 211.72L308.41 211.72L308.97 211.72L309.54 211.72L310.12 211.72ZM309.43 215.62L309.43 222.37L312.57 222.37L312.57 222.33L313.7 222.11L314.78 221.38L315.5 220.31L315.77 218.99L315.5 217.68L314.78 216.61L313.7 215.88L312.57 215.65L312.57 215.62L312.42 215.62L312.39 215.62L312.36 215.62L309.43 215.62Z"></path>
	</svg>
</template>

<script>

export default {
	props: {
		angle: {
			type: [Number, String],
			default: 0
		},
		label: {
			type: String,
			default: 'Mercedes Actros'
		},
		type: {
			type: String,
			validator: (val) => ['parked', 'error', 'driving', 'blue', 'green'].includes(val),
			default: 'error'
		}
	},
	methods: {
		refit() {
			var v = this;

			window.setTimeout(function () {
				var box = v.$refs.label.getBBox();
				var hp = 10;
				var vp = 5;

				v.$refs.labelBackground.setAttribute('x', box.x - hp);
				v.$refs.labelBackground.setAttribute('y', box.y - vp);
				v.$refs.labelBackground.setAttribute('width', box.width + (2 * hp));
				v.$refs.labelBackground.setAttribute('height', box.height + (2 * vp));
				v.$refs.labelBackground.setAttribute('ry', (box.height + (2 * vp)) / 2);
				v.$refs.labelBackground.setAttribute('rx', (box.height + (2 * vp)) / 2);
			}, 200);
		}
	},
	updated() {
		this.refit();
	},
	mounted() {
		this.refit();
	}
}

</script>

<style lang="scss" scoped>
	.svg-marker {
		cursor: pointer;
	}

	.label {
		font-size: 12px;
		fill: black;
		background-color: blue;
		border-bottom: 1px solid black;
	}

	.label-background {
		fill: rgba(255, 255, 255, 0.9);
		border-radius: 50%;
	}

	.marker {
		stroke: white;
		stroke-width: 3px;
		-webkit-filter: drop-shadow(12px 12px 7px rgba(0,0,0,0.5));
		filter: drop-shadow(12px 12px 7px rgba(0,0,0,0.5));  
	}

	.marker.error {
		fill: #f7223f;
	}

	.marker.parked, .marker.blue {
		fill: #2272f7;
	}

	.marker.driving, .marker.green {
		fill: #00c017;
	}

	.icon {
		transform-origin: 313px 226px;
		transform: scale(0.8);
	}

	.arrow {
		transform-origin: 312px 224px;
	}

	.arrow, .parked, .error, .green, .blue {
		fill: white;
	}
</style>